<template>
  <div class="filter-tags" id="filter-tags" v-if="isEnable()">
    <div class="filter-tags__search">
      <label class="form-label">Название тега</label>
      <div class="row g-2">
        <div class="col">
          <div class="input-icon">
            <input @keyup.enter="events.onSearch" type="text" v-model="data.search" class="form-control" placeholder="Для поиска введите название тега">
            <button class="btn input-icon-addon__button" @click="events.onSearch">
              <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <circle cx="10" cy="10" r="7" />
                <line x1="21" y1="21" x2="15" y2="15" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import './css/style.css'
import {defineComponent, onMounted, reactive} from "vue"

export default defineComponent({
  name: "Items",
  props: {
    params: {
      type: Object,
      required: true
    },
  },
  setup(props, {emit}) {
    const variantsData = reactive({
      categories: [],
    })

    let data = reactive({
      search: props.params.search ?? '',
      enable: props.params.enable ?? true,
    })

    const events = {
      onSearch: () => {
        onFilter()
      },
      onStatuses: () => {
        onFilter()
      }
    }

    function onFilter() {
      emit("onFilter", getResult())
    }

    function getResult() {
      return {
        search: data.search,
      }
    }

    function isEnable() {
      return props.params.enable === true
    }

    onMounted(() => {
      onFilter()
    })

    return {
      events,
      data,
      variantsData,
      isEnable,
    }
  }
})
</script>
